const jobCards = [
  'Aktmodell',
  'Altenpfleger/in',
  'Animateur/in auf Aida',
  'Aufseher/in in einem chinesischen Arbeitslager',
  'Auftragskiller/in',
  'Auktionator/in',
  'Bäcker/in',
  'Bademeister/in',
  'Baggerführer/in',
  'Barkeeper/in',
  'Bauer / Bäuerin',
  'Bauleiter/in BER',
  'Bestattungsfachkraft',
  'Beziehungsratgeber/in',
  'Bierbrauer/in',
  'Bundeskanzler/in',
  'Butler',
  'Callcenter-Mitarbeiter/in',
  'Chauffeur/in',
  'Chicken Sexer',
  'Croupier / Croupière in Edel-Casino',
  'Darsteller/in in einer Seifenoper',
  'DHL-Bote/Botin',
  'Dirigent/in des  Staatsorchesters',
  'Entbindungspfleger / Hebamme',
  'Fahrchip-Einsammler/in am Kinderkarussell',
  'Fahrradkurier/in',
  'Filmkritiker/in',
  'Fleischer/in',
  'Fremdenführer/in',
  'Fußballprofi',
  'Gärtner/in',
  'Geheimagent/in',
  'Geisterjäger/in',
  'Glückskeks-Autor/in',
  'Golfballtaucher/in',
  'Grundschullehrer/in',
  'Haustierpräparator/in',
  'Journalist/in',
  'Karnevalsprinz / Karnevalsprinzessin',
  'Kaufhausdetektiv/in',
  'Kaugummiautomatbefüller/in',
  'Kellner/in',
  'KFZ-Mechaniker/in',
  'Koch / Köchin im Sternerestaurant',
  'Marktschreier/in',
  'Masseur/in',
  'Mathematik-Professor/in',
  'Maurer/in',
  'Moderator/in der "Wetten Dass"-Neuauflage',
  'Mondkolonialisierer/in',
  'Nachrichtensprecher/in (Tagesschau)',
  'Personalchef/in',
  'Pfarrer/in',
  'Pilot/in',
  'Polizist/in',
  'Popsänger/in',
  'Pressesprecher/in für Donald Trump',
  'Privater Fitnesscoach',
  'Proband/in für Pharma-Unternehmen',
  'Promi-Friseur/in',
  'Prostituierte/r',
  'Rettungssanitäter/in',
  'Richter/in',
  'Schlangenmelker/in',
  'Schlussmacher/in',
  'Schornsteinfeger/in',
  'Sektenführer/in',
  'Softwareentwickler/in',
  'Spargelstecher/in',
  'StartUp-Investor/in',
  'Staubsaugervertreter/in',
  'Steuerprüfer/in',
  'Steward/ess',
  'Stuntdouble',
  'Synchronschwimmer/in',
  'Tagesvater / Tagesmutter',
  'Tatortreiniger/in',
  'Taxifahrer/in',
  'Theater-Schauspieler/in',
  'Tierarzt / Tierärztin',
  'Tierfutter-Vorkoster/in',
  'Topmodel',
  'Tretbootverleiher/in',
  'Türsteher/in',
  'Umzugshelfer/in',
  'Weihnachtsmann im Supermarkt',
  'Zahnarzt / Zahnärztin',
  'Zirkusclown',
  'Astronaut/in',
  'Dompteur/in',
  'Soldat/in',
  'Wahrsager/in',
  'Fliesenleger/in',
  'Kinderarzt / Kinderärztin',
  'Hausmeister/in im Wohnblock',
  'Stilberater/in',
  'Chefchirurg/in',
  'Boxer/in',
  'Fahrkartenkontrolleur/in',
  'Goldschmied/in',
  'Greenpeace Aktivist/in',
  'Imker/in',
  'Reality-Show-Teilnehmer/in',
  'Restaurantkritiker/in',
  'Virologe / Virologin',
  'Touristenführer/in',
  'Pizzalieferant/in',
  'Kapitän/in der Küstenwache',
  'Spiele-Autor/in',
  'YouTuber/in',
]

export { jobCards }
